@if (cbProject(); as project) {
  <div class="outline-container">
    <!-- Challenge Section -->
    <div class="outline-section challenge-section">
      <p class="section-label">Challenge</p>
      <div class="challenge-content">
        <h2 class="challenge-title">{{ initialGoal() }}</h2>
        @if (selectedGoal(); as goal) {
          <p class="challenge-description">{{ goal.name }}</p>
        }
      </div>
    </div>

    <!-- Objectives Section -->
    @if (selectedObjectives().length) {
      <div class="outline-section">
        <div class="section-header">
          <span class="section-title">Objectives</span>
          <div class="section-bar objectives-bar"></div>
        </div>
        <div class="list-container">
          @for (objective of selectedObjectives(); track objective.name; let i = $index) {
            <div class="list-item">
              <div class="item-number">{{ i + 1 }}</div>
              <span class="item-text">{{ objective.name }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Tasks (Behaviors) Section -->
    @if (selectedTasks().length) {
      <div class="outline-section">
        <div class="section-header">
          <span class="section-title">Tasks</span>
          <div class="section-bar tasks-bar"></div>
        </div>
        <div class="list-container">
          @for (task of selectedTasks(); track task.name; let i = $index) {
            <div class="list-item">
              <div class="item-number tasks-number">{{ i + 1 }}</div>
              <span class="item-text">{{ task.name }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Metrics Section -->
    @if (metrics().length) {
      <div class="outline-section metrics-section">
        <div class="section-header">
          <span class="section-title">Metrics</span>
          <div class="section-bar metrics-bar"></div>
        </div>
        <div class="metrics-chips">
          @for (metric of metrics(); track metric.name) {
            <div class="metric-chip">
              <img class="metric-icon" [src]="getMetricIcon(metric)" [alt]="metric.type" />
              <span class="metric-name">{{ metric.name }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Targets Section -->
    @if (metricsWithTargets()?.length) {
      <div class="outline-section">
        <div class="section-header">
          <span class="section-title">Targets</span>
          <div class="section-bar targets-bar"></div>
        </div>
        <div class="targets-list">
          @for (metric of metricsWithTargets(); track metric.name) {
            <div class="target-row">
              <div class="target-metric-name">{{ metric.name || '(no name)' }}</div>
              <span class="target-value">{{ metric | cbTargetDisplay }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Scheduled Tasks Section -->
    @if (scheduledTasks().length) {
      <div class="outline-section scheduled-tasks-section">
        <div class="section-header">
          <span class="section-title">Scheduled Tasks</span>
          <div class="section-bar scheduled-tasks-bar"></div>
        </div>
        <div class="scheduled-tasks-list">
          @for (task of scheduledTasks(); track task.name) {
            <div class="scheduled-task-item">
              <span class="scheduled-task-name">{{ task.name }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
